import {
  HoldResolutionCollectionComponent,
  HoldResolutionCollectionController
} from './components/hold_resolution_collection/hold_resolution_collection_controller';
import {
  HoldsDetailContentComponent,
  HoldsDetailContentController
} from './components/holds_detail_content/holds_detail_content_controller';
import {
  HoldsListContentComponent,
  HoldsListContentController
} from './components/holds_list_content/holds_list_content_controller';
import { HoldCapabilityConfiguration } from './configuration';
import { HoldModalComponent, HoldModalController, HoldModalService } from './hold_modal/hold_explanation_modal';
import { MyHoldsRoutes } from './routes';
import { HoldsConfigService } from './servants/holds_config_servant';
import { HoldsService } from './services/holds_service';
import { HoldsDetailController } from './views/holds_detail/holds_detail_controller';

angular
  .module('capability-ng-holds', [
    'utility-ng-enumeration',
    'utility-ng-interface',
    'utility-ng-pipeline',
    'utility-ng-network-cache'
  ])
  .service('holdsConfigService', HoldsConfigService)
  .service('holdsService', HoldsService)
  .component('holdsListContent', new HoldsListContentComponent())
  .controller('HoldsListContentController', HoldsListContentController)
  .component('holdsDetailContent', new HoldsDetailContentComponent())
  .controller('HoldsDetailContentController', HoldsDetailContentController)
  .component('holdResolutionCollection', new HoldResolutionCollectionComponent())
  .controller('holdResolutionCollectionController', HoldResolutionCollectionController)
  .component('holdExplainationModal', new HoldModalComponent())
  .controller('HoldModalController', HoldModalController)
  .controller('HoldsDetailController', HoldsDetailController)
  .service('ngHoldModalService', HoldModalService)
  .service('ngHoldCapabilityConfiguration', HoldCapabilityConfiguration)
  .config(MyHoldsRoutes);

import './core';

export * from './builders/holds_builder';
export * from './builders/holdtype_builder';
export * from './builders/resolution_types_builder';
export * from './commands/load_hold_resolutions_command';
export * from './commands/load_holds_list_command';
export * from './commands/update_hold_resolutions_command';
export * from './commands/load_custom_text_command';
export * from './components/hold_resolution_collection/hold_resolution_collection_controller';
export * from './components/holds_detail_content/holds_detail_content_controller';
export * from './components/holds_list_content/holds_list_content_controller';
export * from './configuration';
export * from './datasources/holds_datasource';
export * from './datasources/holdtype_datasource';
export * from './hold_modal/hold_explanation_modal';
export * from './holds_interface';
export * from './queries/holds_list_query';
export * from './queries/holds_priority_feed_query';
export * from './queries/holds_queries_module';
export * from './routes';
export * from './servants/holds_attention_servant';
export * from './servants/holds_config_servant';
export * from './servants/holds_resolution_servant';
export * from './types/holds_types';
export * from './views/holds_detail/holds_detail_controller';
export * from './services/holds_service';
export * from './models/custom_text_model';

export default 'capability-ng-holds';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/main.ts